import { render, staticRenderFns } from "./commercial-new-proposal-action-button.vue?vue&type=template&id=7b4b2d08&"
import script from "./commercial-new-proposal-action-button.vue?vue&type=script&lang=js&"
export * from "./commercial-new-proposal-action-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4b2d08')) {
      api.createRecord('7b4b2d08', component.options)
    } else {
      api.reload('7b4b2d08', component.options)
    }
    module.hot.accept("./commercial-new-proposal-action-button.vue?vue&type=template&id=7b4b2d08&", function () {
      api.rerender('7b4b2d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/commercial-notices/partials/commercial-new-proposal-action-button.vue"
export default component.exports